import styled from 'styled-components';

export const countryImage = styled.img`
        border-radius: 50%;
        width: 21px;
        height: 21px;
        box-shadow: 0px 3px 6px #00000029;
        border: 0.5px solid;
`;